import React from 'react';
import { splitEvery } from 'ramda';
import { Link } from '../Link';
import { tc } from '../../lib/trackingContext';
import { useHomePageJumpLinks } from './useHomePageJumpLinks';

import './HomePageJumpLinksGrid.scss';

const COLUMNS = 2;

export const HomePageJumpLinksGrid: React.FC = () => {
  const flagValue = useHomePageJumpLinks();

  if (!flagValue) return null;

  const rows = splitEvery(COLUMNS, flagValue.items);

  return (
    <div className="HomePageJumpLinksGrid">
      {rows.map((row, rowIndex) => (
        <div className="HomePageJumpLinksGrid__row" key={rowIndex}>
          {row.map(({ label, url }) => (
            <Link
              key={`${label}:${url}`}
              className="HomePageJumpLinksGrid__cell"
              to={url}
              onClick={() =>
                tc.track('Jump Link Clicked', {
                  addToTrackingEvent: { type: label.toLowerCase() }
                })
              }
            >
              {label}
            </Link>
          ))}
        </div>
      ))}
    </div>
  );
};
